import React from 'react';
import { searchResultsContentPropTypes } from './SearchResultsContentPropTypes';
import * as styles from './SearchResultsContent.module.scss';
const SearchResultsContent = ({
  items
}) => {
  if (!items) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, items.map((item, index) => /*#__PURE__*/React.createElement("div", {
    className: styles.rootRow,
    key: index
  }, item.title && /*#__PURE__*/React.createElement("span", {
    className: styles.rootTitle
  }, item.title), item.items && /*#__PURE__*/React.createElement("ul", {
    className: styles.rootList
  }, item.items.map((item, itemIndex) => /*#__PURE__*/React.createElement("li", {
    className: styles.rootListItem,
    key: itemIndex
  }, /*#__PURE__*/React.createElement("a", {
    className: styles.rootListItemLink,
    href: item.href
  }, item.label)))), item.button && /*#__PURE__*/React.createElement("a", {
    className: styles.rootButton,
    href: item.button.href
  }, item.button.label))));
};
export default SearchResultsContent;